import Overview from './overview.vue';
import Full from '@rebuild/materials/shared/news/FullIndex.vue';
import Detail from '@rebuild/materials/shared/news/DetailIndex.vue';
import MobOverview from '@rebuild/materials/shared/news/mobile/MobOverviewIndex.vue';
import MobFull from '@rebuild/materials/shared/news/mobile/FullIndex.vue';
import MobDetail from '@rebuild/materials/shared/news/mobile/DetailIndex.vue';

export const componentMap = {
	overview: Overview,
	full: Full,
	detail: Detail,
	'mob-overview': MobOverview,
	'mob-full': MobFull,
	'mob-detail': MobDetail
}; 